var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BlocageForm',{attrs:{"user":_vm.user,"is-user-departemental":_vm.isUserDepartemental,"cdpe":_vm.cdpe,"annee-scolaire-courante":_vm.anneeScolaireCourante,"saving":_vm.saving},on:{"submit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }